module.exports = __webpack_public_path__ + "static/media/home-insurance.bd598bb3.svg";